import React from 'react';
import { Dialog as HeadlessDialog, DialogPanel, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { cn } from './utils';

export type DrawerSize = 'sm' | 'md' | 'lg';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: DrawerSize;
  className?: string;
}

const sizeClass: Record<DrawerSize, string> = {
  sm: 'bh-drawer__panel--sm',
  md: 'bh-drawer__panel--md',
  lg: 'bh-drawer__panel--lg',
};

export function Drawer({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  className,
}: DrawerProps) {
  return (
    <HeadlessDialog open={open} onClose={onClose} className="bh-drawer">
      <DialogBackdrop className="bh-drawer__backdrop" transition />
      <div className="bh-drawer__container">
        <DialogPanel transition className={cn('bh-drawer__panel', sizeClass[size], className)}>
          <div className="bh-drawer__header">
            {title ? <DialogTitle className="bh-drawer__title">{title}</DialogTitle> : <span />}
            <button type="button" className="bh-drawer__close" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
          <div className="bh-drawer__body">{children}</div>
          {footer ? <div className="bh-drawer__footer">{footer}</div> : null}
        </DialogPanel>
      </div>
    </HeadlessDialog>
  );
}
